import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useOptionalEventRegistrationLanguageContext } from '../EventRegistrationLanguageContext';
export const useEventRegistrationTranslation = () => {
    const { t: tRaw, i18n } = useTranslation();
    const languageContext = useOptionalEventRegistrationLanguageContext();
    const embeddedPreview = languageContext?.embeddedPreview ?? false;
    const selectedLanguageCode = languageContext?.selectedLanguageCode;
    const t = useMemo(() => {
        if (embeddedPreview && selectedLanguageCode) {
            const code = selectedLanguageCode.toLowerCase().split('-')[0];
            return i18n.getFixedT(code);
        }
        return tRaw;
    }, [embeddedPreview, selectedLanguageCode, i18n, tRaw]);
    const activeLanguageCode = embeddedPreview && selectedLanguageCode
        ? selectedLanguageCode.toLowerCase().split('-')[0]
        : (i18n.language ?? 'en');
    return { t, i18n, activeLanguageCode };
};
